const defaultApiUrl =
  process.env.REACT_APP_API_ENV === "production"
    ? "https://api.asteride.co/api/v1/"
    : "https://dev-api.asteride.co/api/v1/";

/** Set REACT_APP_API_URL=http://localhost:5001/api/v1/ to test against local asteride-api */
export const API_URL = process.env.REACT_APP_API_URL || defaultApiUrl;